import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { ValueCards } from '../components/ValueCards';
import { HowItWorks } from '../components/HowItWorks';
import { ConsultancyUseCase } from '../components/ConsultancyUseCase';
import { BackedBy } from '../components/BackedBy';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { Testimonials } from '../components/Testimonials';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-primary-cyan/20 selection:text-primary-blue" data-id="element-375">
      <main data-id="element-376">
        <Hero data-id="element-377" />
        <ProblemSection data-id="element-378" />
        <ValueCards data-id="element-379" />
        <HowItWorks data-id="element-380" />
        <ConsultancyUseCase data-id="element-381" />
        <Testimonials data-id="element-382" />
        <PricingSection data-id="element-383" />
        <BackedBy data-id="element-384" />
        <FinalCTA data-id="element-385" />
      </main>
    </div>;
}